// Horizon 2.1.2: use the theme's own CartUpdateEvent (from the blog you shared)
window.refreshViaHorizonEvent = function () {
  import('@theme/events').then(({ CartUpdateEvent }) => {
    const cartDrawer = document.querySelector('cart-drawer-component');
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const ev = new CartUpdateEvent(cart, 'manual-trigger', {
          itemCount: cart.item_count,
          source: 'custom-refresh',
          sections: {}
        });
        document.dispatchEvent(ev);
        // Open drawer if your setting/markup supports auto-open
        if (cartDrawer?.hasAttribute('auto-open')) {
          cartDrawer.open?.();
        }
      });
  }).catch(() => {
    // If the module isn't available in your build, fall back to the Section Rendering refresh
    window.refreshHorizonCart?.({ openDrawer: true });
  });
};
